export default "__VITE_ASSET__DCCCCXlG__"